<template>
    <b-alert
            class="alert"
            :show="alertDismissCountDown"
            dismissible
            fade
            :variant="variant"
            @dismissed="alertDismiss"
            @dismiss-count-down="alertCountDownChanged"
    >
        {{ message }}
    </b-alert>
</template>

<script>
    export default {
        name: 'alert',
        props: {
            message: {
                type: String,
                default() {
                    return ''
                }
            },
            variant: {
                type: String,
                default() {
                    return 'danger'
                }
            },
            dismissSecs: {
                type: Number,
                default() {
                    return 5
                }
            },
            show: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                alertDismissCountDown: 0,
            }
        },
        watch: {
            show: function (value) {
                if (value) {
                    this.showAlert()
                }
            }
        },
        methods: {
            showAlert: function () {
                this.alertDismissCountDown = this.dismissSecs
                this.$emit('alertShown')
            },

            alertCountDownChanged(dismissCountDown) {
                this.alertDismissCountDown = dismissCountDown
            },

            alertDismiss: function () {
                this.alertDismissCountDown = 0
                this.$emit('alertDismiss')
            }
        }
    }
</script>
